export default __webpack_public_path__ + "static/media/howto-img-03@medium.f5dd68fd.jpg";